import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin, Youtube } from 'lucide-react';
import { Logo } from './Logo';
import { useApp } from '../context/AppContext';

const SOCIALS = [
  { id: 'facebook', Icon: Facebook }, { id: 'instagram', Icon: Instagram }, { id: 'twitter', Icon: Twitter }, { id: 'linkedin', Icon: Linkedin }, { id: 'youtube', Icon: Youtube },
];
const PAYMENT_BADGES = ['Orange Money', 'MTN MoMo', 'Wave', 'Visa'];

const FooterColumn = ({ title, links }) => (
  <div>
    <h4 className="text-white font-semibold mb-4">{title}</h4>
    <ul className="space-y-2.5 text-sm">
      {links.map((l) => (
        <li key={l.id}>
          {l.to ? <Link to={l.to} className="hover:text-[#F2B441] transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</Link>
            : <a href="#" className="hover:text-[#F2B441] transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</a>}
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  const { t } = useApp();
  const columns = [
    { id: 'product', title: t('footer.product'), links: [
      { id: 'marketplace', to: '/marketplace', label: 'Marketplace' }, { id: 'pricing', to: '/pricing', label: t('nav.pricing') },
      { id: 'diaspora', to: '/diaspora', label: t('nav.diaspora') }, { id: 'post', to: '/post', label: t('footer.postAd') } ] },
    { id: 'company', title: t('footer.company'), links: [
      { id: 'about', label: t('footer.about') }, { id: 'careers', label: t('footer.careers') }, { id: 'press', label: t('footer.press') }, { id: 'blog', label: t('footer.blog') } ] },
    { id: 'legal', title: t('footer.legal'), links: [
      { id: 'terms', label: t('footer.terms') }, { id: 'privacy', label: t('footer.privacy') }, { id: 'cookies', label: t('footer.cookies') }, { id: 'help', label: t('footer.help') } ] },
  ];

  return (
    <footer className="bg-[#1A1A1A] text-[#D8D2C5] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="mb-4"><Logo size="lg" /></div>
            <p className="text-[#A8A294] max-w-sm leading-relaxed">{t('footer.tagline')} {t('footer.desc')}</p>
            <div className="flex gap-3 mt-6">
              {SOCIALS.map(({ id, Icon }) => (
                <a key={id} href="#" aria-label={id} className="w-9 h-9 rounded-lg bg-[#2A2A2A] hover:bg-[#0F8B5C] flex items-center justify-center transition-colors"><Icon className="w-4 h-4" /></a>
              ))}
            </div>
          </div>
          {columns.map((c) => <FooterColumn key={c.id} title={c.title} links={c.links} />)}
        </div>
        <div className="border-t border-[#2A2A2A] mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#7A7468]">
          <p>© {new Date().getFullYear()} Kushe Technologies. {t('footer.rights')}</p>
          <div className="flex gap-2 items-center flex-wrap justify-center">
            <span>{t('footer.securePayments')}</span>
            {PAYMENT_BADGES.map((p) => <span key={p} className="px-2 py-1 bg-[#2A2A2A] rounded">{p}</span>)}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
